import { of } from "rxjs";
import { catchError, filter, map, mergeMap } from "rxjs/operators";
import { StateObservable } from "redux-observable";

import { Effect } from "../../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../../redux/types/effect-actions-observable.type";
import { isActionType } from "../../../../redux/action.functions";
import { RootState } from "../../../../redux/store";

import * as executionBriefWorkOrdersServices from "../../services/execution-brief-work-orders.service";

import * as executionBriefStore from "../execution-brief.store";

import * as actions from "./execution-brief-work-orders.actions";
import { ExecutionBriefWorkOrdersActions } from "./execution-brief-work-orders.actions";

const fetchWorkOrders: Effect = (
  action$: EffectActionsObservable,
  state$: StateObservable<RootState>
) =>
  action$.pipe(
    filter(isActionType(ExecutionBriefWorkOrdersActions.FetchWorkOrders)),
    map(() => executionBriefStore.getExecutionBriefId(state$.value)),
    mergeMap((briefId) =>
      executionBriefWorkOrdersServices.fetchWorkOrders(briefId).pipe(
        map((result) => actions.fetchWorkOrdersSuccess(result)),
        catchError((error) => of(actions.fetchWorkOrdersFailure(error)))
      )
    )
  );

export const ExecutionBriefWorkOrdersEffects = [fetchWorkOrders];
